import { apiCall } from './api'

export const getProfile = () => apiCall('getprofile')
